import React from 'react';
import PropTypes from 'prop-types';
import documentType from 'types/documentUpload';
import styles from './documentLink.scss';

const DocumentLink = ({ documents, id }) => {
  const document = documents.find(doc => doc.id === id);
  if (!document) return null;
  return (
    <a target="_blank" rel="noopener noreferrer" href={document.expiring_download_url}>
      {document.document_name}
      {document.not_use && <span className={styles.notUse}> (Do not use)</span>}
    </a>
  );
};

DocumentLink.propTypes = {
  documents: PropTypes.arrayOf(documentType).isRequired,
  id: PropTypes.string,
};

export default DocumentLink;



// WEBPACK FOOTER //
// ./client/app/shared/components/LineItemTable/documentLink.jsx